// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"01032b7f","455":"302854aa","457":"6a7cbf42","484":"58604e98","977":"d0fa7702"}[chunkId] + ".chunk.js";
};